<label *ngIf="globalService.settings.offer.show_prices_conversion" for="select">
    <select (change)="changeTargetCurrency($event, $event.target.value)" id="select">
        <option *ngFor="let currency of currencies"
                [selected]="currency === selectedCurrency"
                [value]="currency">{{currency}}</option>
    </select>
</label>
